import { createFileRoute } from "@tanstack/react-router";
import { SignOutButton } from "@/components/dashboard/sign-out-button";
import { mobileOnly } from "@/content";
import { useSessionState } from "@/context/UserContext";

/**
 * Where a guard lands.
 *
 * The prototype sent them to a bare text node with a logout button, and its own
 * code comment admitted the screen existed only to break an infinite redirect
 * loop. This is the same destination made into an actual answer: it says why they
 * are here and what to use instead.
 *
 * Reads the session loosely rather than through `useSession`, because it is
 * reachable while signed out too — somebody who signs out from here should see the
 * page finish rendering rather than throw on the way to the sign-in screen.
 */
export const Route = createFileRoute("/_auth/mobile-only")({
  component: MobileOnlyPage,
});

function MobileOnlyPage() {
  const state = useSessionState();
  const name = state.status === "signedIn" ? state.session.user.name : null;

  return (
    <div className="rounded-xl border border-white/10 bg-navy-800 p-7 shadow-navy">
      {name ? <span className="bracket">{name}</span> : null}
      <h1 className="mt-5 text-lg font-bold leading-head text-on-navy">{mobileOnly.title}</h1>
      <p className="mt-3 text-sm leading-body text-on-navy-dim">{mobileOnly.lead}</p>
      {name ? (
        <div className="mt-7">
          <SignOutButton />
        </div>
      ) : null}
    </div>
  );
}
